import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
import { problems } from '../data/content';
import { Eyebrow, Mark, SectionTitle } from './ui/Section';
export function Pain() {
  return <section className="bg-white px-4 py-12 md:py-16" data-id="element-176" data-mp="1j1g1maqxe5zp">
      <div className="mx-auto max-w-5xl" data-id="element-177" data-mp="1izv5igoyqezq">
        <Eyebrow data-id="element-178" data-mp="1e2v8eva3cmkr">The reality</Eyebrow>
        <SectionTitle data-id="element-179" data-mp="1e1tnlz39wlpu">
          Do you have exercises, but <Mark data-id="element-180" data-mp="1a11ct1er68rg">no clear system to organize them?</Mark>
        </SectionTitle>
        <p className="mx-auto mt-4 max-w-2xl text-center text-sm leading-relaxed text-steel md:text-base" data-id="element-181" data-mp="1a34dcfdj7kaf">
          Knowing exercises is not the same as having a complete progression.
        </p>

        <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-182" data-mp="10940tsfx7cro">
          {problems.map(problem => <li key={problem} className="flex items-start gap-3 rounded-xl border border-navy/10 bg-canvas p-4" data-id="element-183" data-mp="va0um4o7f0i4">
              <HelpCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-184" data-mp="qevclgxxa5zb" />
              <span className="text-sm font-semibold text-navy" data-id="element-185" data-mp="mdtamscmfftn">{problem}</span>
            </li>)}
        </ul>

        <div className="mt-8 rounded-2xl bg-navy p-5 text-center md:p-6" data-id="element-186" data-mp="23ohw0m1n8ytn">
          <p className="font-display text-lg font-black uppercase leading-tight text-white md:text-2xl" data-id="element-187" data-mp="23pt1qrenggne">
            You need a system that connects <span className="text-brand-light" data-id="element-188" data-mp="1txex9qw6svxj">one step to the next.</span>
          </p>
        </div>
      </div>
    </section>;
}